import type { IUserInfo } from './auth.js';

/**
 * Formats the user's display name, optionally prefixed with a title.
 * @param userInfo - The user info object, or null if the user is not authenticated.
 * @returns The formatted display name (e.g. "Dr. Max Mustermann"), or an empty string.
 */
export function formatDisplayName (userInfo: IUserInfo | null): string {
    if (userInfo === null) {
        return '';
    }

    const parts = [
        userInfo.title,
        userInfo.givenName,
        userInfo.familyName,
    ].filter(Boolean);

    return parts.join(' ');
}

/**
 * The breadcrumb of a page that belongs to the signed-in user rather than to a farm or an
 * organization: their name, standing alone.
 * @param userInfo - The user info object, or null if the user is not authenticated.
 * @returns The one breadcrumb item.
 */
export function userBreadcrumb (userInfo: IUserInfo | null): Array<{ label: string }> {
    return [
        {
            label: formatDisplayName(userInfo),
        },
    ];
}
